enum Action {
  SET_ITEM = 'setItem',
  CLEAR_ITEM = 'clearItem',
  SET_HOVERED_ITEM = 'setHoveredItem',
  CLEAR_HOVERED_ITEM = 'clearHoveredItem',
}

export default Action;
